import * as Blockly from "blockly/core";
import { javascriptGenerator } from "blockly/javascript";
import * as Fr from "blockly/msg/fr";
import * as En from "blockly/msg/en";
import * as It from "blockly/msg/it";
import * as De from "blockly/msg/de";
import { CustomFr } from "../../../lang/CustomFr";
import { CustomDe } from "../../../lang/CustomDe";
import { CustomIt } from "../../../lang/CustomIt";
import { CustomEn } from "../../../lang/CustomEn";
import { initToolbox } from "../../../toolbox/toolbox.mjs";
import { frontendURL } from "../../../../../src/config/settings-network.mjs";

/**
 * Reserved Blockly words.
 * Blockly reserved Words to avoid user overides with its variables the global Eleda variables
 * Have to be updated each time we add class Eleda
 */
var reservedWords = ["Sortable", "Blockly", "math"];
reservedWords.push("parseLatex");
reservedWords.push("_activity", "_questionTemp");
reservedWords.push(
  "Utils",
  "UtilsAlgebra",
  "UtilsList",
  "UtilsNumeric",
  "UtilsFrench"
);
reservedWords.push(
  "Sequence",
  "Activity",
  "Question",
  "Question_Open",
  "Question_MultipleChoice",
  "Question_TrueFalse",
  "Question_Reorder",
  "Question_Associate",
  "Question_Figure",
  "Feedback"
);
reservedWords.push(
  "ElementEleda",
  "Element_Numeric",
  "Element_RichText",
  "Element_Array",
  "Element_TableColumn",
  "Element_TableMatrix",
  "Element_GridColumn",
  "Element_GridMatrix",
  "Element_SpecialCharacter",
  "Element_Markdown",
  "Element_LaTeX",
  "Element_LaTeXParagraph",
  "Element_Matrix"
);
reservedWords.push(
  "Element_GraphicBoard",
  "Element_Figure_Rectangle",
  "Element_Figure_Polygon",
  "Element_Figure_RandomPolygon",
  "Element_Figure_RegularPolygon",
  "Element_Figure_GraphOfFunction",
  "Element_Figure_Point",
  "Element_Figure_Line",
  "Element_Figure_Text",
  "Element_Figure_Circle",
  "Element_Figure_Sector",
  "Element_Algebra",
  "Element_Algebra_Polynom",
  "Element_Algebra_RandomPolynom",
  "Element_Chemical",
  "Element_Media",
  "Element_Media_Image",
  "Element_Media_Video",
  "Element_Media_Audio",
  "Element_Determinant",
  "Element_Adjective",
  "Element_Name",
  "Element_Verb"
);
//Keywords for debuging
reservedWords.push(
  "highlightBlock",
  "_activityDebugVariables",
  "spyDebugVariables",
  "_debugVariables",
  "btnClick"
);
javascriptGenerator.addReservedWords(reservedWords);

export const workspaceCodeGenerator = new Blockly.Workspace();
//Initialisation globale des commentaires dans workspace (doit se faire de manière globale une seule fois)
Blockly.ContextMenuItems.registerCommentOptions();

setBlocklyLang("En");
const commentBubbleDefaultTexts = [
  CustomFr.INFO_COMMENT,
  CustomEn.INFO_COMMENT,
  CustomDe.INFO_COMMENT,
  CustomIt.INFO_COMMENT,
];

function isJSON(text) {
  try {
    var o = JSON.parse(text);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === "object") {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    // console.log("isJSON catch", e);
    return false;
  }
}

// WorkspaceCode can be in XML (iceboxed by Blockly Team) or JSON (modern approach)
export function loadJSONIntoWorkspace(jsonText, workspace) {
  if (isJSON(jsonText)) {
    var json = JSON.parse(jsonText);
    Blockly.serialization.workspaces.load(json, workspace);
  } else {
    var xml = Blockly.utils.xml.textToDom(jsonText); //AB
    Blockly.Xml.domToWorkspace(xml, workspace); //AB
  }
}

// json can be in XML (iceboxed by Blockly Team) or JSON (modern approach)
//return a JSON object with jscode generated, nbBlocks and future other infos...
export function convertJSONWorkspaceIntoJSCode(jsonText) {
  var returnedObject = { jsCode: "", nbBlocks: 0 };
  workspaceCodeGenerator.clear();
  if (isJSON(jsonText)) {
    var json = JSON.parse(jsonText);
    Blockly.serialization.workspaces.load(json, workspaceCodeGenerator);
    returnedObject.origin = "json";
  } else {
    var xml = Blockly.utils.xml.textToDom(jsonText); //AB
    Blockly.Xml.domToWorkspace(xml, workspaceCodeGenerator); //AB
    returnedObject.origin = "xml";
  }
  returnedObject.jsCode = generateCodeActivity(workspaceCodeGenerator, false);
  returnedObject.nbBlocks = workspaceCodeGenerator.getAllBlocks(false).length;
  returnedObject.comment = getWorkspaceCommentBubble(workspaceCodeGenerator);
  return returnedObject;
}

export function getWorkspaceCommentBubble(workspace) {
  if (
    workspace.getBlocksByType("info")[0] &&
    workspace.getBlocksByType("info")[0].getCommentText()
  ) {
    if (
      !commentBubbleDefaultTexts.includes(
        workspace.getBlocksByType("info")[0].getCommentText()
      )
    ) {
      let commentText = workspace.getBlocksByType("info")[0].getCommentText();
      commentText = commentText.replace(/\n/g, "<br />");
      return commentText;
    } else {
      return "";
    }
  } else {
    return "";
  }
}

export function generateCodeSequenceFromActivitiesWithWorkspaceCode(
  activitiesWithWorkspaceCode
) {
  var activitiesWithCode = activitiesWithWorkspaceCode;
  for (let i = 0; i < activitiesWithCode.length; i++) {
    activitiesWithCode[i].code = convertJSONWorkspaceIntoJSCode(
      activitiesWithWorkspaceCode[i].xml
    );
    delete activitiesWithCode[i].xml;
  }
  return activitiesWithCode;
}

/**Disable because directly managed within Workspace listener 
export function showCommentOnHatBlock(workspace) {
  if (workspace.getBlocksByType("info")[0]) {
    var startingBlock = workspace.getBlocksByType("info")[0];
    if (!startingBlock.getCommentText()) {
      startingBlock.setCommentText(Blockly.Msg["INFO_COMMENT"]);
      startingBlock.comment.setBubbleSize(300, 100);
    }
    startingBlock.comment.setVisible(true);
  }
}
*/

/**
 * Blockly Lang Management
 */
export function setBlocklyLang(languageShortCode) {
  if (languageShortCode == "fr") {
    require("../../../lang/CustomFr");
    Blockly.setLocale(Fr);
    // Bug Blockly, en attente correction sur GitHub
    Blockly.Msg["TEXT_CHARAT_TITLE"] = "dans le texte %1 %2 ";
    Blockly.setLocale(CustomFr);
  } else if (languageShortCode == "de") {
    require("../../../lang/CustomDe");
    Blockly.setLocale(De);
    Blockly.setLocale(CustomDe);
  } else if (languageShortCode == "it") {
    require("../../../lang/CustomDe");
    Blockly.setLocale(It);
    Blockly.setLocale(CustomIt);
  } else {
    require("../../../lang/CustomEn");
    Blockly.setLocale(En);
    Blockly.setLocale(CustomEn);
  }
}

/**
 * Generate code from workspace.
 * Structure of code :
 *  1. Vars declarations
 *  2. Internal Blockly functions (randomColour ...)
 * => 1 & 2 done by method finish
 *  3. Blocks procedures designed by users (function tempGraphic1, 2...)
 *  4. Code from Hat Activity Block with all its children
 *  5. Code to add at the end (flags ...)
 *
 *
 * @param workspace
 * @param debugMode
 * @returns
 */

export function generateCodeActivity(workspace, debugMode) {
  var generatedCode = "";
  //window.LoopTrap = 1000;
  //DEFINE RESERVED WORDS TO AVOID USER CHOOSE THESE NAMES AS VARS IN BLOCKLY
  if (debugMode) {
    // in case of debug protect keywork
    //Insert the following line after every statement block code
    //Blockly code has been modified to add this suffix only if block has not an inline parent
    // otherwise the await is in a non async subfunction which raises an error...
    javascriptGenerator.STATEMENT_SUFFIX = `
              workspace.highlightBlock(%1);
              spyDebugVariables();
              await btnClick(runCodeStep);
              `;
  } else {
    javascriptGenerator.STATEMENT_SUFFIX = "";
  }
  javascriptGenerator.INFINITE_LOOP_TRAP =
    'if (--window.LoopTrap == 0) throw "Infinite loop.";\n';

  // identify which is the starting block
  var startingBlock;
  /*if (workspace.getBlocksByType("lang_matrix")[0]) {
    startingBlock = workspace.getBlocksByType("lang_matrix")[0];
  } else*/
  if (workspace.getBlocksByType("info")[0]) {
    startingBlock = workspace.getBlocksByType("info")[0];
  } else {
    startingBlock = null;
  }
  // generate the code with lang_mtrix first or info block and their children
  if (startingBlock) {
    javascriptGenerator.init(workspace);
    //3. Add all procedures blocks

    let procedures = Blockly.Procedures.allProcedures(workspace); //Get tuple of 2 arrays (the first procedures without params the second with params)
    procedures = [...procedures[0], ...procedures[1]];
    procedures.forEach((procedure) => {
      //procedure[0] is the name of procedure => get block named by it
      let defBlock = Blockly.Procedures.getDefinition(procedure[0], workspace);
      if (defBlock) {
        //Does it have a defintion?
        javascriptGenerator.blockToCode(defBlock); //Have it add its code to javascriptGenerator.definitions_
      }
    });
    //4. Activity Code
    // console.log(startingBlock);
    generatedCode += "console.log('Activity is starting');\n";
    generatedCode += javascriptGenerator.blockToCode(startingBlock); // This will generate code for all connected blocks too.
    //Ref : https://groups.google.com/g/blockly/c/8DuZPe1gs94/m/SFK3F0VpDgAJ
    //1. & 2.
    generatedCode = javascriptGenerator.finish(generatedCode);
    //5.
    generatedCode += "_activity.finalizeLoading();\n";
    if (debugMode) {
      //Set the callback function to spy debug to be callable from activity (this callback isonly used to get answer of students when we are in the last step in debug)
      generatedCode += "_activity.setSpyDebugVariables(spyDebugVariables);\n";
    }
    generatedCode += "console.log('Activity is finished');\n";
    generatedCode += "return _activity;\n";
    if (debugMode) {
      generatedCode = addDebugCodeContainer(generatedCode);
    }
  } else {
    //No starting block activity
    generatedCode = "null;";
  }
  return generatedCode;
}
/**
 * Private function to encapsulate activity code in async to be debugable
 * Many tricks to make variables visible from outside scope :
 * A SpyDebugVariables fct load BlocklyVar in a global window Variable _debugVariables to be accessible from Vue
 * At the end (after the last step by step await), we link SpyDebugVariables function to activity to continue to be able to have a look on activity blockly variables
 * : _activity.setSpyDebugVariables makes _activity.updateDebugVariables able to refresh variables (use to display answer of students when multiple attempts)
 * @param code standard code generated by function generateCodeActivity
 * @returns coe with debug features
 */
function addDebugCodeContainer(code) {
  var fullDebugCode;
  //We put the Javascript code in a async function to stop the execution before each click
  const asyncBegining = `
  
  return (async () => {
                  console.log('Activity Debug mode is starting');\n
                  window._debugVariables= [];
                  //This method put variables into activity to be visible from vue ActivityPlay
                    function spyDebugVariables() {
                      //console.log("updateDebugVariables", javascriptGenerator.nameDB_);
                        if (javascriptGenerator.nameDB_) {
                          javascriptGenerator.nameDB_.setVariableMap(workspace.getVariableMap());
                        /*  console.log(
                            "getUsernames",
                            javascriptGenerator.nameDB_.getUserNames("VARIABLE")
                          );*/
                          window._debugVariables = workspace
                            .getAllVariables(workspace)
                            .map((varModel) => {
                              return {
                                id: varModel.getId(),
                                name: varModel.name, //gives the name defined in BlocklyUI eg : "bonnes réponses"
                                generatedCodeName: javascriptGenerator.nameDB_.getName(
                                  varModel.getId(),
                                  Blockly.VARIABLE_CATEGORY_NAME
                                ), //gives variables names as generated by the Blockly generator. eg. bonnes_r_C3_A9ponses
                                value: eval(
                                    javascriptGenerator.nameDB_.getName(
                                      varModel.getId(),
                                      Blockly.VARIABLE_CATEGORY_NAME
                                    )
                                ),
                              };
                            });
                         // console.log("debugVariables",  window._debugVariables );
                        }
                      }

                      function btnClick(btn) {
                        return new Promise(resolve =>  btn.onclick = () => resolve());
                      }\n
                    
                    //  await btnClick(runCodeStep);\n
                     
                     `;

  //javascriptGenerator.INFINITE_LOOP_TRAP = null;
  const endCode = ` })();\n`;
  fullDebugCode = asyncBegining + code + endCode;
  return fullDebugCode;
}

/**
 * Find a Statement block ascendant who start by 'name'
 * Used by feebback and element_figure to know where ithe block is included
 * @param {*} block
 * @param {*} name Name of parent (ascendant) we are looking for
 * @returns
 */
export function findIndexAscendantSuroundedBlockType(block, name) {
  function recursiveFunction(block, name) {
    if (block != null) {
      if (block.type.startsWith(name)) {
        return paternityDegree;
      } else {
        paternityDegree++;
        return recursiveFunction(block.getSurroundParent(), name);
      }
    } else {
      return -1;
    }
  }
  var paternityDegree = 1;
  return recursiveFunction(block, name);
}

/**
 * Find a the first block ascendant who start by one name of a name list
 * Used by feebback and element_figure to know where ithe block is included
 * @param {*} block
 * @param {*} name Name of parent (ascendant) we are looking for
 * @returns Blockly block
 */
export function firstAscendantSuroundedBlockTypeMet(block, names) {
  function recursiveFunction(block, names) {
    if (block != null) {
      let firstNameFound = names.find((name) => block.type.startsWith(name));
      if (firstNameFound !== undefined) {
        return block;
      } else {
        return recursiveFunction(block.getSurroundParent(), names);
      }
    } else {
      return -1;
    }
  }
  return recursiveFunction(block, names);
}

/**
 * Find a Statement block ascendant who start by 'name'
 * Used by feebback and element_figure to know where ithe block is included
 * @param {*} block
 * @param {*} name Name of parent (ascendant) we are looking for
 * @returns
 */
export function getAscendantStatementBlockType(block, name) {
  if (block != null) {
    //console.log("hasAscendantStatementBlockType", block.type);
    if (block.type.startsWith(name)) {
      return block;
    } else {
      return getAscendantStatementBlockType(block.getSurroundParent(), name);
    }
  } else {
    return null;
  }
}

export function updateAllBlocksHELPURL() {
  let categories = new Array();
  let eledaToolboxJson = initToolbox();
  eledaToolboxJson.contents.forEach((element) => {
    if (element.kind == "category") {
      categories.push(element);
      if (element.contents) {
        element.contents.forEach((subElement) => {
          if (subElement.kind == "category") {
            categories.push(subElement);
          }
        });
      }
    }
  });

  //Get all blocks to render
  categories.forEach((cat) => {
    if (cat.contents) {
      cat.contents.forEach((block) => {
        if (block.kind == "block") {
          Blockly.Msg[block.type.toUpperCase() + "_HELPURL"] =
            "https://eleda.education/documentation#" + block.type;
          //OVERIDE ALSO CATNAME_BLOCKNAME_... because BLockly is not consistent with globalvar
          // See = https://groups.google.com/g/blockly/c/FlGjDhkUVJE
          Blockly.Msg[
            cat.name_universal.toUpperCase() +
              "_" +
              block.type.toUpperCase() +
              "_HELPURL"
          ] = frontendURL + "/documentation#" + block.type;
          Blockly.Msg["VARIABLES_SET_HELPURL"] = ""; // set var
          Blockly.Msg["VARIABLES_GET_HELPURL"] = ""; // get var
          Blockly.Msg["MATH_CHANGE_HELPURL"] = ""; // change var
        }
      });
    }
  });
}

/*************************************************************************
 * BELOW OVERIDES BLOCKLY FUNCTION
 * *************************************************************************/
/**
 * OVERIDES BLOCKLY FUNCTION FOR DEBUG FEATURE
 * PATCH BLOCKLY FOR Eleda CB 04/17/2021if a block has at least one valueBlock parent (rounded shape block)
 * Find recursively
 */
function hasAscendantValueBlock(block) {
  if (block != null) {
    if (!block.getPreviousBlock()) {
      return true;
    } else {
      return hasAscendantValueBlock(block.getSurroundParent());
    }
  } else {
    return false;
  }
}

/**
 * PATCHED PATCH BLOCKLY FOR ELEDA CB 17 04/17/21
 * If hasAscendantValueBlock, desactivate add suffix and prefix to make debug mode works
 * Inject a block ID into a message to replace '%1'.
 * Used for STATEMENT_PREFIX, STATEMENT_SUFFIX, and INFINITE_LOOP_TRAP.
 * @param {string} msg Code snippet with '%1'.
 * @param {!Blockly.Block} block Block which has an ID.
 * @return {string} Code snippet with ID.
 */

Blockly.Generator.prototype.injectId = function (msg, block) {
  if (
    (msg == this.STATEMENT_PREFIX || msg == this.STATEMENT_SUFFIX) &&
    !hasAscendantValueBlock(block)
  ) {
    var id = block.id.replace(/\$/g, "$$$$"); // Issue 251.
    return msg.replace(/%1/g, "'" + id + "'");
  } else {
    return "";
  }
};

/**
 * Verified if has children start with
 */
export function hasChildValueBlock(block, name) {
  var result = false;
  if (block != null) {
    for (let i = 0; i < block.getChildren().length; i++) {
      var childBlock = block.getChildren()[i];
      if (childBlock.type.startsWith(name)) {
        result = true;
      }
    }
  }
  return result;
}

export function searchBlockName(startingBlock, name) {
  // Vérifier si le bloc actuel est un bloc 'version'
  if (startingBlock.type === name) {
    return startingBlock; // Retourne le bloc version trouvé
  }

  // Parcourir tous les blocs connectés
  let childBlocks = startingBlock.getChildren();
  for (let child of childBlocks) {
    let result = searchBlockName(child, name);
    if (result) {
      return result; // Retourne le bloc version si trouvé dans les enfants
    }
  }

  return null; // Aucun bloc version trouvé dans cette branche
}

/**
 * OVERIDE MATH BLOCKLY OPERATORS TO ADD ROUNDTO14DIGITS METHOD : to prevent issue JS issue
 * @param {*} block
 * @returns
 */
/*
javascriptGenerator.forBlock["math_number"] = function(block) {
  // Numeric value.
  const code = "math.bignumber(" + block.getFieldValue("NUM") + ")";
  const order =
    code >= 0
      ? javascriptGenerator.ORDER_ATOMIC
      : javascriptGenerator.ORDER_UNARY_NEGATION;
  return [code, order];
};
*/

Blockly.Blocks["math_arithmetic"] = {
  init: function () {
    this.jsonInit({
      type: "math_arithmetic",
      message0: "%1 %2 %3",
      args0: [
        {
          type: "input_value",
          name: "A",
          check: ["Number", "Expression", "Array"],
        },
        {
          type: "field_dropdown",
          name: "OP",
          options: [
            ["%{BKY_MATH_ADDITION_SYMBOL}", "ADD"],
            ["%{BKY_MATH_SUBTRACTION_SYMBOL}", "MINUS"],
            ["%{BKY_MATH_MULTIPLICATION_SYMBOL}", "MULTIPLY"],
            ["%{BKY_MATH_DIVISION_SYMBOL}", "DIVIDE"],
            ["%{BKY_MATH_POWER_SYMBOL}", "POWER"],
          ],
        },
        {
          type: "input_value",
          name: "B",
          check: ["Number", "Expression", "Array"],
        },
      ],
      inputsInline: true,
      output: null,
      colour: "%{BKY_ALGEBRA_HUE}",
      helpUrl: "%{BKY_MATH_ARITHMETIC_HELPURL}",
      extensions: ["math_op_tooltip"],
    });
  },
};

javascriptGenerator.forBlock["math_random_int"] = function (block) {
  // Random integer between [X] and [Y].

  var value_type = "integer";
  var value_min =
    javascriptGenerator.valueToCode(
      block,
      "FROM",
      javascriptGenerator.ORDER_NONE
    ) || "0";
  var value_max =
    javascriptGenerator.valueToCode(
      block,
      "TO",
      javascriptGenerator.ORDER_NONE
    ) || "0";

  // TODO: Assemble JavaScript into code variable.
  var code = "";
  let type = value_type == "integer";

  code =
    "UtilsNumeric.getRandomNum(" +
    value_min +
    "," +
    value_max +
    "," +
    type +
    ")";

  return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
};

javascriptGenerator.forBlock["math_arithmetic"] = function (block) {
  // Basic arithmetic operators, and power.
  const OPERATORS = {
    ADD: ["ADD", javascriptGenerator.ORDER_ADDITION],
    MINUS: ["MINUS", javascriptGenerator.ORDER_SUBTRACTION],
    MULTIPLY: ["MULTIPLY", javascriptGenerator.ORDER_MULTIPLICATION],
    DIVIDE: ["DIVIDE", javascriptGenerator.ORDER_DIVISION],
    POWER: ["POWER", javascriptGenerator.ORDER_FUNCTION_CALL], // Handle power separately.
  };
  const tuple = OPERATORS[block.getFieldValue("OP")];
  const operator = tuple[0];
  const order = tuple[1];
  const argument0 = javascriptGenerator.valueToCode(block, "A", order) || "0";
  const argument1 = javascriptGenerator.valueToCode(block, "B", order) || "0";
  let code;

  code =
    "UtilsNumeric.arithmetic('" +
    operator +
    "'," +
    argument0 +
    "," +
    argument1 +
    ")";

  return [code, order];
};

javascriptGenerator.forBlock["math_single"] = function (block) {
  // Math operators with single operand.
  const operator = block.getFieldValue("OP");
  let code;
  let arg;
  if (operator === "NEG") {
    // Negation is a special case given its different operator precedence.
    arg =
      javascriptGenerator.valueToCode(
        block,
        "NUM",
        javascriptGenerator.ORDER_UNARY_NEGATION
      ) || "0";
    if (arg[0] === "-") {
      // --3 is not legal in JS.
      arg = " " + arg;
    }
    code = "-" + arg;
    return [code, javascriptGenerator.ORDER_UNARY_NEGATION];
  }
  if (operator === "SIN" || operator === "COS" || operator === "TAN") {
    arg =
      javascriptGenerator.valueToCode(
        block,
        "NUM",
        javascriptGenerator.ORDER_DIVISION
      ) || "0";
  } else {
    arg =
      javascriptGenerator.valueToCode(
        block,
        "NUM",
        javascriptGenerator.ORDER_NONE
      ) || "0";
  }

  let order;
  // First, handle cases which generate values that don't need parentheses
  // wrapping the code.
  if (
    [
      "ABS",
      "ROOT",
      "LN",
      "EXP",
      "POW10",
      "ROUND",
      "ROUNDUP",
      "ROUNDDOWN",
      "SIN",
      "COS",
      "TAN",
    ].includes(operator)
  ) {
    order = javascriptGenerator.ORDER_FUNCTION_CALL;
  } else if (["LOG10", "ASIN", "ACOS", "ATAN"].includes(operator)) {
    order = javascriptGenerator.ORDER_DIVISION;
  } else {
    order = javascriptGenerator.ORDER_NONE;
    throw Error("Unknown math operator: " + operator);
  }

  return ["UtilsNumeric.single('" + operator + "'," + arg + ")", order];
};

javascriptGenerator.forBlock["math_constant"] = function (block) {
  // Constants: PI, E, the Golden Ratio, sqrt(2), 1/sqrt(2), INFINITY.
  const CONSTANTS = {
    PI: ["math.PI", javascriptGenerator.ORDER_MEMBER],
    E: ["math.E", javascriptGenerator.ORDER_MEMBER],
    GOLDEN_RATIO: [
      "(1 + math.sqrt(5)) / 2",
      javascriptGenerator.ORDER_DIVISION,
    ],
    SQRT2: ["math.SQRT2", javascriptGenerator.ORDER_MEMBER],
    SQRT1_2: ["math.SQRT1_2", javascriptGenerator.ORDER_MEMBER],
    INFINITY: ["math.Infinity", javascriptGenerator.ORDER_ATOMIC],
  };
  return CONSTANTS[block.getFieldValue("CONSTANT")];
};

javascriptGenerator.forBlock["math_on_list"] = function (block) {
  // Math functions for lists.
  const func = block.getFieldValue("OP");
  const list =
    javascriptGenerator.valueToCode(
      block,
      "LIST",
      javascriptGenerator.ORDER_NONE
    ) || "[]";
  let code;
  switch (func) {
    case "SUM":
      code = "UtilsNumeric.sum(" + list + ")";
      break;
    case "MIN":
      code = "math.min( " + list + ")";
      break;
    case "MAX":
      code = "math.max( " + list + ")";
      break;
    case "AVERAGE": {
      code = "UtilsNumeric.mean(" + list + ")";
      break;
    }
    case "MEDIAN": {
      code = "UtilsNumeric.median(" + list + ")";
      break;
    }
    case "MODE": {
      // As a list of numbers can contain more than one mode,
      // the returned result is provided as an array.
      // Mode of [3, 'x', 'x', 1, 1, 2, '3'] -> ['x', 1].
      code = "UtilsNumeric.mode(" + list + ")";
      break;
    }
    case "STD_DEV": {
      code = "UtilsNumeric.std(" + list + ")";
      break;
    }
    case "RANDOM": {
      code = "UtilsList.randomElementsFromArray(" + list + ")";
      break;
    }
    default:
      throw Error("Unknown operator: " + func);
  }
  return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
};

/** OVERIDE LOGIC */
javascriptGenerator.forBlock["logic_compare"] = function (block) {
  // Comparison operator.
  const OPERATORS = {
    EQ: "==",
    NEQ: "!=",
    LT: "<",
    LTE: "<=",
    GT: ">",
    GTE: ">=",
  };
  const operator = OPERATORS[block.getFieldValue("OP")];
  const order =
    operator === "==" || operator === "!="
      ? javascriptGenerator.ORDER_EQUALITY
      : javascriptGenerator.ORDER_RELATIONAL;
  const argument0 = javascriptGenerator.valueToCode(block, "A", order) || "0";
  const argument1 = javascriptGenerator.valueToCode(block, "B", order) || "0";

  const code =
    "UtilsNumeric.compare('" +
    operator +
    "'," +
    argument0 +
    ", " +
    argument1 +
    ")";
  return [code, order];
};

/** OVERIDE LISTS */
// BUG identified by Loic when try to reverse a rounded list (rounded return number or numbers list rounded)
Blockly.Blocks["lists_reverse"] = {
  init: function () {
    this.jsonInit({
      type: "lists_reverse",
      message0: "%{BKY_LISTS_REVERSE_MESSAGE0}",
      args0: [
        {
          type: "input_value",
          name: "LIST",
          check: null, // originally ["Array"]
        },
      ],
      output: "Array",
      inputsInline: true,
      style: "list_blocks",
      tooltip: "%{BKY_LISTS_REVERSE_TOOLTIP}",
      helpUrl: "%{BKY_LISTS_REVERSE_HELPURL}",
    });
  },
};
